import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import CachedIcon from '@mui/icons-material/Cached';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import Groups2Icon from '@mui/icons-material/Groups2';
import HistoryIcon from '@mui/icons-material/History';
import ImageIcon from '@mui/icons-material/Image';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LoopIcon from '@mui/icons-material/Loop';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PeopleIcon from '@mui/icons-material/People';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import ShareIcon from '@mui/icons-material/Share';
import { Box } from '@mui/material';

import { ROUTES } from '../routes/path';
import { RoleEnum } from '../types';

const menuItems = [
  {
    text: 'Dashboard',
    icon: <Box component="img" src={require('../assets/icons/ic_dashboard.svg').default} alt="Dashboard" sx={{ width: 21.5, height: 21.5 }} />,
    requireRole: RoleEnum.Dashboard,
    path: '/',
  },
  {
    text: 'Quà tặng',
    icon: <CardGiftcardIcon />,
    path: ROUTES.REWARD.LIST,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Người chơi',
    icon: <Box component="img" src={require('../assets/icons/ic_user.svg').default} alt="User" sx={{ width: 21.5, height: 21.5 }} />,
    path: ROUTES.USER_PROFILE,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Gieo Quẻ',
    icon: <Box component="img" src={require('../assets/icons/ic_team.svg').default} alt="Team" sx={{ width: 21.5, height: 21.5 }} />,
    path: ROUTES.HEXAGRAM.LIST,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Nội dung gợi ý',
    icon: <Box component="img" src={require('../assets/icons/ic_tournament.svg').default} alt="Tournament" sx={{ width: 21.5, height: 21.5 }} />,
    path: ROUTES.SUGGESTIONS.LIST,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Cấu hình',
    icon: <PermDataSettingIcon />,
    path: '/config',
    requireRole: RoleEnum.Editor,
    subItems: [
      {
        text: 'Gói cước',
        path: ROUTES.CONFIG.PACKAGE.LIST,
        icon: <PhoneInTalkIcon />,
      },
      {
        text: 'Link chia sẻ',
        path: ROUTES.CONFIG.SHARE_LINK.LIST,
        icon: <ShareIcon />,
      },
      {
        text: 'Ảnh nền',
        path: ROUTES.CONFIG.BACKGROUND.LIST,
        icon: <ImageIcon />,
      },
      {
        text: 'Thể lệ',
        path: ROUTES.CONFIG.RULES.LIST,
        icon: <AlignVerticalCenterIcon />,
      },
    ],
  },
  {
    text: 'Lịch sử',
    icon: <HistoryIcon height={21.5} />,
    path: '/logs',
    requireRole: RoleEnum.Editor,
    subItems: [
      {
        text: 'Lịch sử lượt chơi',
        path: ROUTES.LOG.PLAYER_TURNS,
        icon: <LoopIcon />,
      },
      {
        text: 'Lịch sử nhận thưởng',
        path: ROUTES.LOG.REWARD,
        icon: <CardGiftcardIcon />,
      },
      {
        text: 'Lịch sử gieo quẻ',
        path: ROUTES.LOG.HEXAGRAM,
        icon: <LeaderboardIcon />,
      },
      {
        text: 'Lịch sử nhận lì xì',
        path: ROUTES.LOG.LUCKY_MONEY,
        icon: <Box component="img" src={require('../assets/icons/ic_quiz_game.svg').default} alt="Quiz" sx={{ width: 21.5, height: 21.5 }} />,
      },
    ],
  },
  {
    text: 'Cài đặt',
    icon: <Box component="img" src={require('../assets/icons/ic_setting.svg').default} alt="Setting" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/setting',
    requireRole: RoleEnum.Admin,
    subItems: [
      {
        text: 'Cache System',
        path: ROUTES.SETTING.CACHE_SYSTEM,
        icon: <CachedIcon />,
      },
      {
        text: 'Quản lý người dùng',
        path: ROUTES.SETTING.USER_MANAGEMENT,
        icon: <ManageAccountsIcon />,
      },
    ],
  },
];

const SCOPE = {
  ADMIN: RoleEnum.Admin,
  EDITOR: RoleEnum.Editor,
  DASHBOARD: RoleEnum.Dashboard,
};

const ACTION_TYPE = {
  EDIT: 'edit',
  ADD: 'add',
};

export const COMMON = {
  APP_VERSION: '1.0.0',
  LABEL_DATE_FROM: 'Ngày bắt đầu',
  LABEL_DATE_TO: 'Ngày kết thúc',
  FORMAT_DATE: 'dd/MM/yyyy',
  FORMAT_DATE_TIME: 'dd/MM/yyyy, HH:mm:ss',
  FORMAT_ISO_DATE: 'yyyy-MM-dd',

  BTN_SEARCH: 'Tìm kiếm',
  BTN_ADD: 'Thêm mới',
  BTN_DELETE: 'Xoá',
  BTN_CANCEL: 'Huỷ bỏ',
  BTN_UPDATE: 'Cập nhật',
  BTN_CONFIRM_RESULT: 'Xác nhận kết quả',
  BTN_CONFIRM: 'Xác nhận',
  BTN_IMPORT: 'Nhập file',

  STATE_SUCCESS: 'success',
  STATE_ERROR: 'error',
};

const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

const DAY_TYPE = {
  HAC_DAO: {
    label: 'Hắc đạo',
    value: 'HAC_DAO',
  },
  HOANG_DAO: {
    label: 'Hoàng đạo',
    value: 'HOANG_DAO',
  },
};

const GENDER = {
  MALE: {
    label: 'Nam',
    value: 'MALE',
  },
  FEMALE: {
    label: 'Nữ',
    value: 'FEMALE',
  },
};

const TOPIC = {
  KET_GIAO: {
    label: 'Kết giao',
    value: 'KET_GIAO',
  },
  KET_TAM: {
    label: 'Kết tâm',
    value: 'KET_TAM',
  },
  KET_LOC: {
    label: 'Kết lộc',
    value: 'KET_LOC',
  },
  KET_DA: {
    label: 'Kết đà',
    value: 'KET_DA',
  },
  KET_Y: {
    label: 'Kết ý',
    value: 'KET_Y',
  },
};

export { ACTION_TYPE, menuItems, SCOPE, STATUS, DAY_TYPE, GENDER, TOPIC };
